function App() {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Ambitus Technology Solutions</h1>
      <p style={styles.subheading}>We're building something great.</p>
      <p style={styles.text}>Our website is currently under construction...<br/>
      We'll be back soon!</p>
      <p style={styles.email}>📧 info@ambitustechnology.com.au</p>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#0a0a2e',
    color: '#ffffff',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    padding: '20px'
  },
  heading: {
    fontSize: '2.5rem',
    marginBottom: '10px',
    color: '#00aaff'
  },
  subheading: {
    fontSize: '1.5rem',
    marginBottom: '20px',
    color: '#cccccc'
  },
  text: {
    fontSize: '1rem',
    lineHeight: '1.8',
    color: '#aaaaaa'
  },
  email: {
    marginTop: '30px',
    fontSize: '1rem',
    color: '#00aaff'
  }
};

export default App;